import MultiSelectDropdown from "cpl-react-common/components/Inputs/MultiSelectDropdown";

import { useSelector } from "react-redux";
import {
  getPropertyManagerSelectModels,
  selectLastUpdateTime,
  selectLoading,
  selectPropertyManagerSelectModels,
} from "./components/PropertyManagerSelectSlice";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import useCaching, { CachingOptions } from "cpl-react-common/Hooks/useCaching";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

type PropertyManagerSelectProps = {
  "data-test-id"?: string;
  handleChange: (selections: string[]) => void;
  defaultAll: boolean;
  defaultSome?: string[];
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 60; // 1 hour

const PropertyManagerSelectMulti: React.FC<PropertyManagerSelectProps> = (props) => {
  const thunkDispatch = useThunkDispatch();
  const loading = useSelector(selectLoading);
  const propertyManagerSelectModels = useSelector(selectPropertyManagerSelectModels);
  const lastUpdateTime = useSelector(selectLastUpdateTime);

  const updateSelectModels = () => {
    thunkDispatch(getPropertyManagerSelectModels());
  };
  const cachingOptions: CachingOptions = {
    lastUpdateTime,
    expiryPeriodMs: EXPIRY_PERIOD_MS,
    updateData: updateSelectModels,
    shouldUpdateOnLoad: propertyManagerSelectModels.length === 0,
  };

  useCaching(cachingOptions);

  return (
    <ActivityIndicator isBusy={loading}>
      <MultiSelectDropdown
        data-test-id={props["data-test-id"]}
        handleChange={(selections) => props.handleChange(selections as string[])}
        options={propertyManagerSelectModels.map((x) => ({
          value: x.value!,
          label: x.label ?? "",
        }))}
        defaultAll={props.defaultAll}
        defaultSome={props.defaultSome}
        searchable={true}
      ></MultiSelectDropdown>
    </ActivityIndicator>
  );
};

export default PropertyManagerSelectMulti;
